import React from 'react';

interface StepIndicatorProps {
  currentStep: number;
  totalSteps: number;
}

export const StepIndicator: React.FC<StepIndicatorProps> = ({ currentStep, totalSteps }) => {
  const progress = (currentStep / totalSteps) * 100;

  return (
    <div>
      <div className="h-px bg-border relative">
        <div
          className="h-full bg-primary transition-all duration-400"
          style={{ width: `${progress}%` }}
        />
      </div>
      <div className="mt-4 text-xs text-secondary tracking-wider">
        Étape {currentStep} sur {totalSteps}
      </div>
    </div>
  );
};
